module.exports = __webpack_public_path__ + "static/img/gengxinkuai.53e12bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/gengxinkuai.png
// module id = js4s
// module chunks = 0